import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=5ba788be&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=5ba788be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba788be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ba788be')) {
      api.createRecord('5ba788be', component.options)
    } else {
      api.reload('5ba788be', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=5ba788be&scoped=true&", function () {
      api.rerender('5ba788be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2y5dtU1ZP57HR/JS/teamMember.vue"
export default component.exports